import { type StoreState } from '../../../store'
import { key } from './quotes.reducer'

const getQuotesStore = (state: StoreState) => state[key]

export const quotesView = (state: StoreState) => getQuotesStore(state).quotesView
